
export const monetaryConverter = (number) => {
  let decimalSize = Number.parseFloat(number).toLocaleString().split(',')[1] ? Number.parseFloat(number).toLocaleString().split(',')[1].length : null

  if (!decimalSize) {
    return number.toLocaleString() + ",00"
  }
  else if (decimalSize === 1) {
    return number.toLocaleString() + "0"
  } else {
    return number.toLocaleString()
  }
}